import React from 'react'
import { Field } from 'redux-form'
import { translate } from 'parking-react-common'

import { ui, forms } from '../redux'

import form from '../components/Form'
import Input from '../components/Input'
import Button from '../components/Button'

const EmailSignupForm = ({ isSubmitting, isPristine, t }) => (
    <div>
        <Field
            name="email"
            placeholder={ t('Email Address') }
            component={ Input }
        />
        <Field
            name="password1"
            placeholder={ t('Password') }
            type="password"
            component={ Input }
        />
        <Field
            name="password2"
            placeholder={ t('Password Confirmation') }
            type="password"
            component={ Input }
        />
        <Button
            type="submit"
            label={ t('Sign Up') }
            size={ ui.SIZE.large }
            intent={ ui.INTENT.primary }
            isBlock
            disabled={ isSubmitting || isPristine }
        />
    </div>
)

EmailSignupForm.propTypes = forms.propTypes

export default translate()(form({ id: forms.emailSignup.id })(EmailSignupForm))
